import List, { type ListProps } from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import type { DecoratedUnisonProject } from '@witmetrics/utils';
import { formatUserName, isBlank } from '@witmetrics/utils/strings';
import { getProjectType } from '@witmetrics/unison-core';
import { classes, styles } from './utils';

export interface ResultsListProps extends Omit<
  ListProps,
  'results' | 'onSelect'
> {
  onSelect: (id: number) => void;
  results?: DecoratedUnisonProject[];
}

export default function ResultsList({
  results = [],
  onSelect,
  ...props
}: ResultsListProps) {
  const renderDescription = ({
    user,
    description,
    unisonProjectTypeId,
  }: DecoratedUnisonProject) => {
    let result = '';
    const projectType = getProjectType(unisonProjectTypeId)?.label;
    if (!user || !isBlank(description)) {
      result = description;
    } else {
      result = `${formatUserName(user)}${user.externalRef ? ` - ${user.externalRef}` : ''}`;
    }
    return projectType ? `${projectType} | ${result}` : result;
  };

  return (
    <List {...props}>
      {results.map((p) => {
        return (
          <ListItem key={p.id} disablePadding>
            <ListItemButton
              sx={styles.listItemButton}
              className={classes.listItemButton}
              onClick={() => onSelect(p.id)}>
              <ListItemText primary={p.name} secondary={renderDescription(p)} />
            </ListItemButton>
          </ListItem>
        );
      })}
    </List>
  );
}
